var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import gql from "graphql-tag";
var query = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query UserEmailAddressAvailableQuery($emailAddress: String!) {\n    userEmailAddressAvailableStatus(emailAddress: $emailAddress)\n  }\n"], ["\n  query UserEmailAddressAvailableQuery($emailAddress: String!) {\n    userEmailAddressAvailableStatus(emailAddress: $emailAddress)\n  }\n"])));
export var createUserEmailAddressAvailable = function (apollo, $t) { return ({
    getMessage: function () {
        return $t("This email address is already associated with a user account").toString();
    },
    validate: function (emailAddress) {
        if (!emailAddress) {
            return Promise.resolve(true);
        }
        return apollo
            .query({
            query: query,
            variables: { emailAddress: emailAddress },
        })
            .then(function (response) {
            return response.data.userEmailAddressAvailableStatus === "available";
        });
    },
}); };
export var createUserEmailAddressAvailableOrRequiresActivation = function (apollo, $t) { return ({
    getMessage: function () {
        return $t("This email address is already associated with an active user account").toString();
    },
    validate: function (emailAddress) {
        if (!emailAddress) {
            return Promise.resolve(true);
        }
        return apollo
            .query({ query: query, variables: { emailAddress: emailAddress } })
            .then(function (response) {
            return response.data.userEmailAddressAvailableStatus !== "not-available";
        });
    },
}); };
export var createUserEmailAddressDoesntRequireActivation = function (apollo, $t, message) { return ({
    getMessage: function () {
        if (message !== undefined) {
            return message;
        }
        return $t("This email address is associated with a user account that needs to sign in").toString();
    },
    validate: function (emailAddress) {
        if (!emailAddress) {
            return Promise.resolve(true);
        }
        return apollo
            .query({ query: query, variables: { emailAddress: emailAddress } })
            .then(function (response) {
            return response.data.userEmailAddressAvailableStatus !==
                "from-agent-requires-activation";
        });
    },
}); };
var templateObject_1;
